import { render, staticRenderFns } from "./_total.vue?vue&type=template&id=19b19b86&scoped=true&"
import script from "./_total.vue?vue&type=script&lang=js&"
export * from "./_total.vue?vue&type=script&lang=js&"
import style0 from "./_total.vue?vue&type=style&index=0&id=19b19b86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b19b86",
  null
  
)

export default component.exports